<template>
  <div class="mt-4" @submit.prevent="sendForm">
    <div class="mb-4 border-red-light border-t-4 font-light rounded-b bg-red-lightest px-4 py-3 text-red-darker" role="alert" v-show="errors" v-text="errors"></div>
    <div class="mb-4 border-green-light border-t-4 font-light rounded-b bg-green-lightest px-4 py-3 text-green-darker" role="alert" v-show="success" v-text="success"></div>
    <label for="card-element" class="block uppercase tracking-wide text-charcoal-darker text-xs font-bold">
        Credit or debit card
      </label>
    <div class="flex items-stretch">
      <div ref="card"></div>
      <button @click="submitPayment" class="bg-blue text-white p-4 rounded-r">Submit Payment</button>
      <!-- Used to display form errors. -->
    </div>
  </div>
</template>

<script>
if (window.DTK) {
  let stripe = Stripe(window.DTK.stripeKey),
      elements = stripe.elements(),
      card = undefined
}
export default {
  props: ['planId', 'user', 'complete'],
  data() {
    return {
      errors: '',
      success: ''
    }
  },
  mounted() {
    card = elements.create('card')
    card.mount(this.$refs.card)
  },
  methods: {
    submitPayment(e) {
      stripe.createToken(card).then((result) => {
        if (result.error) {
          this.errors = result.error.message
          this.hasCardErrors = true
          this.$forceUpdate()
          return
        }
        console.log(result.token)

        axios.post('/api/v1/subscribe', {
          user: this.user,
          planId: this.planId,
          stripeToken: result.token.id,
          last4: result.token.card.last4,
          expMonth: result.token.card.exp_month,
          expYear: result.token.card.exp_year,
          brand: result.token.card.brand
        }).then(({data}) => {
          this.success = data.success
          this.$emit('subscriptionSet')
        })
      })
    },
    changed(e) {
      if (e.error) {
        this.errors = e.error.message
      }
    }
  }
}
</script>
